import { FormControl, Grid, TextField, Typography } from '@mui/material'
import React from 'react'

export const UncollectibleAccounts = ({ useFetchInit }) => {

  const { 
    //------------- Generales
    location,
    paramsURL,
    //------------- globalStates
    globalStates,
    //------------- FetchData
    FetchData,
    //------------- Actions
    Actions,
    //------------- helpers
    Helpers,
    //------------- Formularios
    Forms
    
} = useFetchInit


  // ------------------------------------------------ Formularios
  const { FormRequestGlobal } = Forms
  const { 
      formState, 
      onInputChange, 
      onInputChangeForCheckBox,
      onDropZoneAcceptedFilesChange, 
      onDropZoneRejectionsFilesChange, 
  } = FormRequestGlobal

  const { formOpeningMode} = globalStates

  //------------------------------------------------- Fech data

  //------------------------------------------------- Actions
  const {handleClickShowModal, onSubmitFormFiles} = Actions
  return (
    <>
      <Typography sx={{mt:3,fontWeight: 'bold'}} variant='subtitle2'>
          Informacion sobre la gestion
      </Typography>
      <div className="border-bottom border-dark"></div>
      <Grid container columnSpacing={{ xs: 12, sm: 12, md: 4, lg: 4 }} sx={{ mb: 2, mt: 2 }}>
        <Grid item xs={12} sm={12} md={6} lg={6}>
          <FormControl fullWidth>
            <label htmlFor="aprobacion_fecha">Fecha de Aprobacion del Credito</label>
            <TextField
                id='aprobacion_fecha'
                name='aprobacion_fecha'
                value={ formState.aprobacion_fecha }
                onChange={ onInputChange }
                size='small'
                placeholder=''
                type='text'
                variant='filled'
                InputProps={{
                    readOnly: true
                }}
                required
            />
          </FormControl>
        </Grid>
        <Grid item xs={12} sm={12} md={6} lg={6}>
          <FormControl fullWidth>
            <label htmlFor="plazo">Plazo del Credito (meses)</label>
            <TextField
                id='plazo'
                name='plazo'
                value={ formState.plazo }
                onChange={ onInputChange }
                size='small'
                placeholder='Plazo en Meses'
                type='number'
                variant='filled'
                InputProps={{
                    readOnly: true
                }}
                required
            />
          </FormControl>
        </Grid>    
      </Grid>

      <Grid container columnSpacing={{ xs: 12, sm: 12, md: 4, lg: 4 }} sx={{ mb: 2, mt: 2 }}>
        <Grid item xs={12} sm={12} md={4} lg={4}>
          <FormControl fullWidth>
            <label htmlFor="monto_venta">Monto Total Del Credito (Q)</label>
            <TextField
                id='monto_venta'
                name='monto_venta'
                value={ formState.monto_venta }
                onChange={ onInputChange }
                size='small'
                placeholder='Monto Total'
                type='text'
                variant='filled'
                InputProps={{
                    readOnly: true
                }}
                required
            />
          </FormControl>
        </Grid>
        <Grid item xs={12} sm={12} md={4} lg={4}>
          <FormControl fullWidth>
            <label htmlFor="saldo_financiar">Monto a Financiar (Q)</label>
            <TextField
                id='saldo_financiar'
                name='saldo_financiar'
                value={ formState.saldo_financiar }
                onChange={ onInputChange }
                size='small'
                placeholder='Monto a Financiar'
                type='text'
                variant='filled'
                InputProps={{
                    readOnly: true
                }}
                required
            />
          </FormControl>
        </Grid>    
        <Grid item xs={12} sm={12} md={4} lg={4}>
          <FormControl fullWidth>
            <label htmlFor="monto_enganche">Monto del Enganche (Q)</label>
            <TextField
                id='monto_enganche'
                name='monto_enganche'
                value={ formState.monto_enganche }
                onChange={ onInputChange }
                size='small'
                placeholder='Monto del Enganche'
                type='text'
                variant='filled'
                InputProps={{
                    readOnly: true
                }}
                required
            />
          </FormControl>
        </Grid>
      </Grid>
      <Grid container columnSpacing={{ xs: 12, sm: 12, md: 4, lg: 4 }} sx={{ mb: 2 }}>
        <Grid item xs={12} sm={12} md={3} lg={3}>
          <FormControl fullWidth>
            <label htmlFor="interes">Porcentaje del Interes (%)</label>
            <TextField
                id='interes'
                name='interes'
                value={ formState.interes }
                onChange={ onInputChange }
                size='small'
                placeholder='Porcentaje del Interes'
                type='number'
                variant='filled'
                InputProps={{
                  readOnly: true
                }}
                required
            />
          </FormControl>
        </Grid>     
        <Grid item xs={12} sm={12} md={3} lg={3}>
          <FormControl fullWidth>
            <label htmlFor="gps">GPS</label>
            <TextField
                id='gps'
                name='gps'
                value={ formState.gps }
                onChange={ onInputChange }
                size='small'
                placeholder='GPS'
                type='text'
                variant='filled'
                InputProps={{
                    readOnly: true
                }}
                required
            />
          </FormControl>
        </Grid>
        <Grid item xs={12} sm={12} md={3} lg={3}>
          <FormControl fullWidth>
            <label htmlFor="seguro">Seguro</label>
            <TextField
                id='seguro'
                name='seguro'
                value={ formState.seguro }
                onChange={ onInputChange }
                size='small'
                placeholder='Seguro'
                type='text'
                variant='filled'
                InputProps={{
                    readOnly: true
                }}
                required
            />
          </FormControl>
        </Grid>
        <Grid item xs={12} sm={12} md={3} lg={3}>
          <FormControl fullWidth>
            <label htmlFor="otros">Otros</label>
            <TextField
                id='otros'
                name='otros'
                value={ formState.otros }
                onChange={ onInputChange }
                size='small'
                placeholder='Otros'
                type='text'
                variant='filled'
                InputProps={{
                    readOnly: true
                }}
                required
            />
          </FormControl>
        </Grid>
      </Grid>

      <Grid container columnSpacing={{ xs: 12, sm: 12, md: 4, lg: 4 }} sx={{ mb: 2 }}>
        <Grid item xs={12} sm={12} md={6} lg={6}>
          <FormControl fullWidth>
            <label htmlFor="total_cuota">Total Cuota (Q)</label>
            <TextField
                id='total_cuota'
                name='total_cuota'
                value={ formState.total_cuota }
                onChange={ onInputChange }
                size='small'
                placeholder='Total Cuota'
                type='text'
                variant='filled'
                InputProps={{
                    readOnly: true
                }}
                required
            />
          </FormControl>
        </Grid>
        <Grid item xs={12} sm={12} md={6} lg={6}>
          <FormControl fullWidth>
            <label htmlFor="cuota_niv">Cuota Nivelada (Q)</label>
            <TextField
                id='cuota_niv'
                name='cuota_niv'
                value={ formState.cuota_niv }
                onChange={ onInputChange }
                size='small'
                placeholder='Cuota Nivelada'
                type='text'
                variant='filled'
                InputProps={{
                    readOnly: true
                }}
                required
            />
          </FormControl>
        </Grid>
      </Grid>

      <Grid container columnSpacing={{ xs: 12, sm: 12, md: 4, lg: 4 }}>
        <Grid item xs={12} sm={12} md={12} lg={12} sx={{ mb: 1, mt: 2 }}>
            <FormControl fullWidth>
                <label htmlFor="gestion_descripcion">* Descripcion</label>
                <TextField
                    id='gestion_descripcion'
                    name='gestion_descripcion'
                    value={ formState.gestion_descripcion } 
                    onChange={ onInputChange }
                    size='small'
                    placeholder='Descripcion'
                    type='text'
                    multiline
                    rows={5}
                    variant={(formOpeningMode==='READONLY')? 'filled': 'outlined'}
                    InputProps={{
                        readOnly: (formOpeningMode==='READONLY') ? true: false,
                        maxLength: 200
                    }}
                    required
                />
                <Typography
                  variant="caption"
                  align="right"
                  color={formState.gestion_descripcion.length >= 500 ? 'error' : 'textSecondary'}
                >
                {formState.gestion_descripcion.length} / 500
            </Typography>
            </FormControl>
        </Grid>
      </Grid>
    </>
  )
}
